import ParametersController from './parametersController';

const ParametersComponent = {
    template: require('./parametersView.html'),
    controller: ParametersController,
    bindings: {
        skillId: '=',
        skillName: '=',
        areaName: '=',
        stepName: '=',
    },
};

export default ParametersComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepPedagogicalApproach/pages/parameters/parametersComponent.js